import React, { forwardRef } from "react";
import SoftBoxRoot from "./SoftBoxRoot";
import { BoxProps } from "@mui/material/Box";

interface SoftBoxProps extends BoxProps {
  variant?: "contained" | "gradient";
  bgColor?: string;
  color?: string;
  opacity?: number;
  borderRadius?: string;
  shadow?: string;
}

const SoftBox = forwardRef<HTMLDivElement, SoftBoxProps>(
  (
    {
      variant = "contained",
      bgColor = "transparent",
      color = "dark",
      opacity = 1,
      borderRadius = "none",
      shadow = "none",
      ...rest
    },
    ref
  ) => (
    <SoftBoxRoot
      {...rest}
      ref={ref}
      ownerState={{ variant, bgColor, color, opacity, borderRadius, shadow }}
    />
  )
);

SoftBox.displayName = "SoftBox";

export default SoftBox;
